import { Stack, Grid, MenuItem } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  width: 100%;
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 16px;
  padding: 8px;
  @media (max-width: 650px) {
    padding: 8px 0px;
  }
`;

export const StyledDateBox = styled.div`
  width: 100% !important;
  & .rmdp-container {
    width: 100% !important;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  text-align: right !important;
  direction: rtl;
`;

export const StyledGridIcons = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  & button {
    box-shadow: -2px -2px 15px #dbdbdb, 2px 2px 15px #cacaca;
    margin: 0px 10px;
    padding: 5px;
    & svg {
      border: none !important;
      border-radius: 100%;
      box-shadow: none !important;
      @media (max-width: 700px) {
        font-size: 24px;
      }
    }
    @media (max-width: 700px) {
      margin: 0px 5px;
    }
    @media (max-width: 599px) {
      margin: 10px 8px 0px;
    }
  }
  & :hover {
    box-shadow: inset -2px -2px 5px #dbdbdb, inset 2px 2px 5px #cacaca;
    & button {
      & svg {
        box-shadow: none;
      }
    }
  }
  @media (max-width: 600px) {
    justify-content: left;
  }
`;
